import { FileExpire } from './../_models/FileExpire';
import { ToasterService } from './../_services/Toaster.service';
import { DeviceService } from '../_services/_DeviceService/Device.service';
import { OverallDevices } from './../_models/OverallDevices';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Device } from '../_models/Device';
import { Subscription, interval } from 'rxjs';
import { AuthService } from '../_services/authService/auth.service';
import { PreloaderService } from '../_services/Preloader.service';
import { Router, Data } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
// import * as Chartist from 'chartist';
// import { ChartType, ChartEvent } from "ng-chartist";

// export interface Chart {
//   type: ChartType;
//   data: Chartist.IChartistData;
//   options?: any;
//   responsiveOptions?: any;
//   events?: ChartEvent;
// }

@Component({
  selector: 'app-Home',
  templateUrl: './Home.component.html',
  styleUrls: ['./Home.component.css'],
})
export class HomeComponent implements OnInit, AfterViewInit {
  public OverallDevices: OverallDevices;
  Device: Device[];
  data: Device;
  DeviceOld: Device[];
  DeviceNew: Device[];
  private updateSubscription: Subscription;
  DaysLeft: any;
  DatatableInint = true;



  constructor(
    private SpinnerService: NgxSpinnerService,
    private router: Router,
    private authService: AuthService,
    private DeviceService: DeviceService,
    private noti: ToasterService,
    private preloader: PreloaderService
  ) {}

 async ngOnInit() {
    this.DatatableInint = false;
    this.SpinnerService.show();
    this.LoadDeviceStatus();
    this.DeviceNew=  await  this.LoadAllDevices();
    this.DeviceOld=this.DeviceNew;

     this.updateSubscription = interval(2000).subscribe(async (val) =>  {
      this.LoadDeviceStatus();
      this.DeviceNew= await this.LoadAllDevices();
      if(this.DeviceNew.length!=this.DeviceOld.length)
      {
        this.DatatableInint=false;
        this.DeviceOld=this.DeviceNew;

      }
      else
      {
        this.DeviceNew.forEach((element,key) => {
         this.DeviceOld[key].deviceName=element.deviceName;
         this.DeviceOld[key].lastUpdatedTime=element.lastUpdatedTime;
         this.DeviceOld[key].connected=element.connected;

        });

      }
    });

    this.preloader.hide();
  }



  ngAfterViewInit(): void {
    this.CheckMac();
  }

  LoadDeviceStatus() {
    try {
      this.DeviceService.GetOverAllDeviceStatus().subscribe(
        (Response) => {
          if (Response.status == 200) {
            this.OverallDevices = Response.body;
          }
          this.sleep(1000);
          this.SpinnerService.hide();
        },
        (error) => {
          this.SpinnerService.hide();
        }
      );
    } catch (error) {
      this.SpinnerService.hide();
    }
  }
  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  CheckMac() {
    try {
      this.authService.CheckMac().subscribe(
        (Response) => {
          if (Response.status == 200) {
            if (Response.body != 't') {
              $('#ExpireModalClick').click();
              this.DaysLeft = Response.body.daysLeft;
            }
          }
        },
        (err) => {
          if (err.status == 404) {
            this.router.navigateByUrl('/error');
          }
        }
      );
    } catch (error) {
      if (error.status == 404) {
      }
    }
  }
async  LoadAllDevices() {
   // this.DatatableInint = false;.

    try {
      await this.DeviceService.GetDeviceList().toPromise().then(
        (Response) => {
          if (Response.status == 200) {
            this.Device = Response.body;


            this.Device.forEach((element) => {
              var date = new Date(element.lastUpdatedTime);
              element.lastUpdatedTime =
                date.getDate().toString() +
                '-' +
                (date.getMonth() + 1) +
                '-' +
                date.getFullYear() +
                '  ' +
                date.getHours() +
                ':' +
                date.getMinutes() +
                ':00';
            });
            this.SpinnerService.hide();

            this.DatatableInint = true;
          } else {
            this.noti.error('Error', Response.body);
            this.DatatableInint = true;

            this.SpinnerService.hide();
          }
        },
        (err) => {
          if (err.status == 401) {
            this.DatatableInint = true;
            this.SpinnerService.hide();

           // window.location.reload();
          } else {
            this.noti.error('Error', err.error);
            this.DatatableInint = true;
            this.SpinnerService.hide();
          }
        }
      );

   return this.Device;

    } catch (error) {
      this.noti.error('Error', 'Code Crashed');
      this.DatatableInint = true;
      this.SpinnerService.hide();
    }
  }

  public loadScript(url: string) {
    const body = document.body as HTMLDivElement;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }
}
